import {
  initializeDataVersion,
  type GameToolVersionFetcher,
} from "@huyafed/gametool-data-runtime";
import type { DataRuntimeConfig } from "../config/dataRuntime";

export interface TierListDataVersionContext {
  version: string;
  dataRoot: string;
}

export type { GameToolVersionFetcher };

export async function initializeTierListDataVersion(
  config: DataRuntimeConfig,
  location: Pick<Location, "search" | "hash">,
  getVersion: GameToolVersionFetcher,
): Promise<TierListDataVersionContext> {
  const context = await initializeDataVersion(config, location, getVersion);

  return {
    version: context.version,
    dataRoot: context.versionRoot,
  };
}
